import { useMemo, useState } from 'react';
import { Box, Divider, Popover, Stack, Typography } from '@mui/material';
import StarRoundedIcon from '@mui/icons-material/StarRounded';

const formatScore = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return '—';
  }
  if (Number(value) === 0) return '—';
  return Number(value).toFixed(1).replace(/\.0$/, '');
};

const LessonScoreCell = ({ lesson }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const scores = useMemo(
    () => [
      { label: 'Оцінка за ДЗ', value: lesson.homeworkScore },
      { label: 'Активність', value: lesson.activityScore },
      { label: 'Поведінка', value: lesson.behaviorScore },
      { label: 'Засвоєння матеріалу', value: lesson.comprehensionScore },
    ],
    [lesson.activityScore, lesson.behaviorScore, lesson.comprehensionScore, lesson.homeworkScore]
  );

  const averageScore = useMemo(() => {
    const valid = scores.filter((item) => item.value != null && Number(item.value) > 0);
    if (!valid.length) {
      return '—';
    }
    const avg = valid.reduce((sum, item) => sum + Number(item.value), 0) / valid.length;
    return avg.toFixed(1);
  }, [scores]);

  const open = Boolean(anchorEl);
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Box
        onClick={handleOpen}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          px: 1.5,
          py: 0.75,
          borderRadius: 2,
          bgcolor: '#F1F5F9',
          border: '1px solid #E2E8F0',
          cursor: 'pointer',
          transition: 'background 0.2s ease, border 0.2s ease',
          '&:hover': {
            bgcolor: '#E2E8F0',
            borderColor: '#CBD5F5',
          },
        }}
      >
        <Typography variant="body2" fontWeight={600} color="text.primary">
          Оцінка: {averageScore}
        </Typography>
        <StarRoundedIcon sx={{ color: '#FBBF24' }} fontSize="small" />
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        PaperProps={{
          sx: {
            px: 2,
            py: 1.5,
            borderRadius: 2,
            border: '1px solid #E2E8F0',
            boxShadow: '0 10px 30px rgba(15, 23, 42, 0.12)',
            minWidth: 220,
          },
        }}
      >
        <Stack spacing={1}>
          <Typography variant="subtitle2" color="text.secondary">
            Деталі оцінювання
          </Typography>
          <Divider />
          {scores.map((item) => (
            <Stack key={item.label} direction="row" justifyContent="space-between">
              <Typography variant="body2" color="text.secondary">
                {item.label}
              </Typography>
              <Typography variant="body2" fontWeight={600} color="primary.main">
                {formatScore(item.value)}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Popover>
    </>
  );
};

export default LessonScoreCell;



